/**
 * Product Selector Quote Form
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'ps-quote-form';
const log = debug(MODULE_NAME);


//
// Dependencies
const Vue = window.Vue;
import uniqueId from 'lodash/uniqueId';
import { QuoteFormComponent } from '@core/modules/ps-quote-form/components';


/**
 * Initialises the quote form.
 * @param {Element} element
 */
export default function init(element) {
	element.id = uniqueId('ps-qf');
	let quoteForm = QuoteFormComponent(element);

	// Run Vue
	let vm = new Vue({
		el: `#${element.id}`,
		components: {
			'ps-quote-form': quoteForm
		}
	});

	log('Quote Form Vue vm:', vm);
	return vm;
}




// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/index.js